import { forwardRef, useImperativeHandle, useRef } from 'react'
import { downloadCsv } from './importExportApi'

const FileDownload = forwardRef((_, ref) => {
  const anchorRef = useRef<any>()
  useImperativeHandle(ref, () => ({
    download: async (url: string, suggestedFileName: string, post: boolean = false) => {
      const file = await downloadCsv(url, post)

      const blobUrl = URL.createObjectURL(new Blob([file]))
      anchorRef.current.href = blobUrl
      anchorRef.current.download = suggestedFileName
      anchorRef.current.click()

      setTimeout(() => {
        URL.revokeObjectURL(url)
        anchorRef.current.href = ''
        anchorRef.current.download = ''
      }, 1000)
    }
  }))

  return <a ref={anchorRef} download style={{display: 'none'}}>Download</a>
})

export default FileDownload